var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClaim = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58131 4.7352C4.38457 4.54143 4.06799 4.54385 3.87423 4.7406C3.68046 4.93734 3.68288 5.25392 3.87962 5.44768L4.58131 4.7352ZM6.53816 7.36417L6.18732 7.72041L6.53816 8.06594L6.88901 7.72041L6.53816 7.36417ZM12.889 1.81132C13.0858 1.61755 13.0882 1.30098 12.8944 1.10423C12.7006 0.907487 12.3841 0.90507 12.1873 1.09884L12.889 1.81132ZM3.87962 5.44768L6.18732 7.72041L6.88901 7.00793L4.58131 4.7352L3.87962 5.44768ZM6.88901 7.72041L12.889 1.81132L12.1873 1.09884L6.18732 7.00793L6.88901 7.72041Z",
    fill: "#253561"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2426 2.4082C8.51875 2.4082 8.7426 2.18435 8.7426 1.9082C8.7426 1.63206 8.51875 1.4082 8.2426 1.4082V2.4082ZM11.6538 6.45366C11.6538 6.17752 11.43 5.95366 11.1538 5.95366C10.8777 5.95366 10.6538 6.17752 10.6538 6.45366H11.6538ZM9.15385 9.59002H3V10.59H9.15385V9.59002ZM1.5 8.09002V3.9082H0.5V8.09002H1.5ZM3 2.4082H8.2426V1.4082H3V2.4082ZM10.6538 6.45366V8.09002H11.6538V6.45366H10.6538ZM3 9.59002C2.17157 9.59002 1.5 8.91845 1.5 8.09002H0.5C0.5 9.47073 1.61929 10.59 3 10.59V9.59002ZM9.15385 10.59C10.5346 10.59 11.6538 9.47073 11.6538 8.09002H10.6538C10.6538 8.91845 9.98227 9.59002 9.15385 9.59002V10.59ZM1.5 3.9082C1.5 3.07978 2.17157 2.4082 3 2.4082V1.4082C1.61929 1.4082 0.5 2.52749 0.5 3.9082H1.5Z",
    fill: "#253561"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClaim);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/claim.deee4ab0518e95acbc82fa03c7afee9b.svg";